"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const CopyCode = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "stroke",
  d: "M2.6 12.2A1.6 1.6 0 011 10.6v-8A1.6 1.6 0 012.6 1h8a1.6 1.6 0 011.6 1.6",
  stroke: "#ACB3BE",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "stroke",
  d: "M15.4 5.8h-8a1.6 1.6 0 00-1.6 1.6v8A1.6 1.6 0 007.4 17h8a1.6 1.6 0 001.6-1.6v-8a1.6 1.6 0 00-1.6-1.6z",
  stroke: "#ACB3BE",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "stroke",
  d: "M9.8 9.8L9 11.4l.8 1.6M13 9.8l.8 1.6L13 13",
  stroke: "#ACB3BE",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _default = CopyCode;
exports.default = _default;